/* mgn-card · Carrusel táctil + bolsa AJAX (Magnora, estilo LV) */
(function(){
  if (window.__mgncInit) return;
  window.__mgncInit = true;

  function initCard(card){
    if (card.dataset.mgncReady) return;
    card.dataset.mgncReady = '1';
    if (!card.hasAttribute('data-swipe')) return;
    var media = card.querySelector('.mgnc__media');
    var slides = card.querySelectorAll('.mgnc__slide');
    var bar = card.querySelector('.mgnc__dots');
    if (!media || slides.length < 2 || !bar) return;
    bar.hidden = false;
    var thumb = document.createElement('span');
    thumb.style.width = (100 / slides.length) + '%';
    bar.appendChild(thumb);
    var i = 0, swiped = false, x0 = null;
    function go(n){
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      thumb.style.transform = 'translateX(' + (i * 100) + '%)';
    }
    media.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
    media.addEventListener('touchend', function(e){
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40){
        go(dx < 0 ? i + 1 : i - 1);
        swiped = true;
        setTimeout(function(){ swiped = false; }, 450);
      }
      x0 = null;
    }, {passive:true});
    media.addEventListener('click', function(e){ if (swiped) e.preventDefault(); });
  }

  function initAll(){
    document.querySelectorAll('[data-mgnc]').forEach(initCard);
  }

  /* Bolsa: delegación global (sobrevive re-renders AJAX) */
  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('.mgnc__bag') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    if (btn.dataset.action === 'product'){ window.location.href = btn.dataset.url; return; }
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] })
    })
    .then(function(r){ if(!r.ok){ throw new Error('cart'); } return r.json(); })
    .then(function(){
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function(){ btn.classList.remove('is-added'); }, 1600);
    })
    .catch(function(){
      btn.classList.remove('is-loading');
      window.location.href = btn.dataset.url;
    });
  });

  /* Re-inicializa tarjetas inyectadas por AJAX (ej. recomendaciones de producto) */
  var mo = new MutationObserver(function(muts){
    for (var m = 0; m < muts.length; m++){
      if (muts[m].addedNodes.length){ initAll(); break; }
    }
  });

  function start(){
    initAll();
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
